import {Order} from '../../types';
export function filterPinned(orders: Order[], returnRest = false) : Order[] {
    return orders
        .filter(order => {
            if(returnRest) return !order.isPinned;
            return order.isPinned;
        })
}